"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
const external_frame_1 = require("@clearsummit/external-frame");
Object.defineProperty(exports, "Breadcrumb", { enumerable: true, get: function () { return external_frame_1.Breadcrumb; } });
